import { render, staticRenderFns } from "./RentalObjectRooms.vue?vue&type=template&id=42c83abc&scoped=true&"
import script from "./RentalObjectRooms.vue?vue&type=script&lang=js&"
export * from "./RentalObjectRooms.vue?vue&type=script&lang=js&"
import style0 from "./RentalObjectRooms.vue?vue&type=style&index=0&id=42c83abc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c83abc",
  null
  
)

export default component.exports